angular.module('mean.builders').factory('builderService', ['$filter', '$q', 'Users',
    function($filter, $q, Users) {

        var isBuilder = function(username) {
            var array = username.split('', 9);
            var trade = array[0] + array[1];

            return (trade === '00');
        }

        return {
            isBuilder: isBuilder
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/builders/public/services/builder-service.js